// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ActionAreaView-module__root___kCwj9 {
  display: block;
}

.ActionAreaView-module__pageHeader___NGat7 {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 16px;
}

.ActionAreaView-module__pageTitle___sLuXU {
  font-size: 20px;
  font-weight: 600;
  color: #18181b;
  margin: 0 auto 0 0;
}

.ActionAreaView-module__segmentedControl___RmFMr {
  display: flex;
  gap: 2px;
  background: #f4f4f5;
  border-radius: 6px;
  padding: 2px;
}

.ActionAreaView-module__segmentButtonActive___l6Hxd {
  padding: 4px 12px;
  font-size: 13px;
  font-weight: 500;
  border-radius: 4px;
  border: none;
  background: #ffffff;
  color: #18181b;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);
  cursor: default;
}

.ActionAreaView-module__toolbar___aIZnQ {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 10px 0;
  margin-bottom: 8px;
}

.ActionAreaView-module__periodRow___xj8aK {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  column-gap: 16px;
  row-gap: 10px;
  padding: 16px;
  background: #ffffff;
  border: 1px solid #e4e4e7;
  border-radius: 8px;
}

.ActionAreaView-module__presetGroup___ggd4r {
  display: flex;
  gap: 4px;
  background: #f4f4f5;
  border-radius: 6px;
  padding: 2px;
}

.ActionAreaView-module__presetButton___JAFbo {
  padding: 3px 10px;
  font-size: 13px;
  font-weight: 500;
  border-radius: 4px;
  border: 1px solid transparent;
  background: transparent;
  color: #71717a;
  cursor: pointer;
}

.ActionAreaView-module__presetButton___JAFbo:hover {
  color: #3f3f46;
}

.ActionAreaView-module__presetButtonActive___ER3oT {
  background: #ffffff;
  color: #18181b;
  border-color: #e4e4e7;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);
}

.ActionAreaView-module__dayChips___u0Spq {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
}

.ActionAreaView-module__dayChip___t9tUD {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  white-space: nowrap;
  padding: 6px 14px;
  font-size: 13px;
  border-radius: 999px;
  border: 1px solid #d4d4d8;
  background: #ffffff;
  color: #3f3f46;
  cursor: pointer;
  transition: border-color 0.15s ease, color 0.15s ease, background-color 0.15s ease;
}

.ActionAreaView-module__dayChip___t9tUD:hover {
  border-color: #18181b;
  color: #18181b;
}

.ActionAreaView-module__dayChipActive___qFG63 {
  border-color: #18181b;
  background: #18181b;
  color: #ffffff;
}

.ActionAreaView-module__dayChipCount___IvCRO {
  font-size: 12px;
  color: #a1a1aa;
}

.ActionAreaView-module__dayChipActive___qFG63 .ActionAreaView-module__dayChipCount___IvCRO {
  color: #d4d4d8;
}

.ActionAreaView-module__pickDateLabel___F1q97 {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 13px;
  color: #71717a;
}

.ActionAreaView-module__dateInput___FaE8j {
  padding: 4px 8px;
  font-size: 13px;
  border-radius: 6px;
  border: 1px solid #e4e4e7;
  background: #ffffff;
  color: #3f3f46;
}

.ActionAreaView-module__readout___BcLSV {
  margin-left: auto;
  white-space: nowrap;
  font-size: 13px;
  color: #71717a;
}

.ActionAreaView-module__handoffCard___G3bVf {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 16px;
  margin-top: 12px;
  padding: 16px;
  background: #ffffff;
  border: 1px solid #e4e4e7;
  border-radius: 8px;
}

.ActionAreaView-module__handoffIcon___ZAAOr {
  flex-shrink: 0;
  color: #71717a;
}

.ActionAreaView-module__handoffText___wfqY9 {
  margin-right: auto;
  min-width: 0;
}

.ActionAreaView-module__handoffTitle___UZ_Od {
  margin: 0;
  font-size: 15px;
  font-weight: 600;
  color: #18181b;
}

.ActionAreaView-module__handoffSubtitle___lhKDh {
  margin: 2px 0 0;
  font-size: 13px;
  color: #71717a;
}

.ActionAreaView-module__handoffButton___K1940 {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  flex-shrink: 0;
  padding: 6px 14px;
  font-size: 13px;
  font-weight: 500;
  border-radius: 6px;
  border: 1px solid #e4e4e7;
  background: #ffffff;
  color: #18181b;
  cursor: pointer;
}

.ActionAreaView-module__handoffButton___K1940:hover {
  background: #f4f4f5;
}

.ActionAreaView-module__dayList___fnOwt {
  margin-top: 12px;
  padding: 16px;
  background: #ffffff;
  border: 1px solid #e4e4e7;
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  gap: 24px;
}

.ActionAreaView-module__dayListHeader___DgR47 {
  display: flex;
  align-items: baseline;
  gap: 10px;
  flex-wrap: wrap;
}

.ActionAreaView-module__dayListTitle___ELI6U {
  margin: 0;
  font-size: 17px;
  font-weight: 600;
  color: #18181b;
}

.ActionAreaView-module__dayListCount___hVaVg {
  font-size: 17px;
  color: #a1a1aa;
}

.ActionAreaView-module__dayListSummary___aHkHn {
  margin-left: auto;
  font-size: 13px;
  color: #71717a;
  white-space: nowrap;
}

.ActionAreaView-module__emptyState___PGM7v {
  margin: 0;
  font-size: 13px;
  color: #71717a;
}

.ActionAreaView-module__dayGroup___ADlHF {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.ActionAreaView-module__dayHeading___qH_yu {
  margin: 0;
  display: flex;
  flex-wrap: wrap;
  align-items: baseline;
  gap: 8px;
  font-size: 18px;
  font-weight: 600;
  color: #18181b;
}

.ActionAreaView-module__dayHeadingQuiet___CN_Ae {
  font-size: 15px;
  font-weight: 400;
  color: #71717a;
}

.ActionAreaView-module__dayRows___miaNA {
  display: flex;
  flex-direction: column;
  gap: 10px;
}`, "",{"version":3,"sources":["webpack://./src/pages/CareOrchestration/components/ActionAreaView/ActionAreaView.module.scss"],"names":[],"mappings":"AAAA;EACE,cAAA;AACF;;AAEA;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,mBAAA;AACF;;AAEA;EACE,eAAA;EACA,gBAAA;EACA,cAAA;EACA,kBAAA;AACF;;AAEA;EACE,aAAA;EACA,QAAA;EACA,mBAAA;EACA,kBAAA;EACA,YAAA;AACF;;AAEA;EACE,iBAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,YAAA;EACA,mBAAA;EACA,cAAA;EACA,yCAAA;EACA,eAAA;AACF;;AAEA;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,eAAA;EACA,kBAAA;AACF;;AAEA;EACE,aAAA;EACA,eAAA;EACA,mBAAA;EACA,gBAAA;EACA,aAAA;EACA,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,kBAAA;AACF;;AAEA;EACE,aAAA;EACA,QAAA;EACA,mBAAA;EACA,kBAAA;EACA,YAAA;AACF;;AAEA;EACE,iBAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,6BAAA;EACA,uBAAA;EACA,cAAA;EACA,eAAA;AACF;;AAEA;EACE,cAAA;AACF;;AAEA;EACE,mBAAA;EACA,cAAA;EACA,qBAAA;EACA,yCAAA;AACF;;AAEA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,eAAA;AACF;;AAEA;EACE,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,mBAAA;EACA,iBAAA;EACA,eAAA;EACA,oBAAA;EACA,yBAAA;EACA,mBAAA;EACA,cAAA;EACA,eAAA;EACA,kFAAA;AACF;;AAEA;EACE,qBAAA;EACA,cAAA;AACF;;AAEA;EACE,qBAAA;EACA,mBAAA;EACA,cAAA;AACF;;AAEA;EACE,eAAA;EACA,cAAA;AACF;;AAEA;EACE,cAAA;AACF;;AAEA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,eAAA;EACA,cAAA;AACF;;AAEA;EACE,gBAAA;EACA,eAAA;EACA,kBAAA;EACA,yBAAA;EACA,mBAAA;EACA,cAAA;AACF;;AAEA;EACE,iBAAA;EACA,mBAAA;EACA,eAAA;EACA,cAAA;AACF;;AAEA;EACE,aAAA;EACA,eAAA;EACA,mBAAA;EACA,SAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,kBAAA;AACF;;AAEA;EACE,cAAA;EACA,cAAA;AACF;;AAEA;EACE,kBAAA;EACA,YAAA;AACF;;AAEA;EACE,SAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;AACF;;AAEA;EACE,eAAA;EACA,eAAA;EACA,cAAA;AACF;;AAEA;EACE,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,cAAA;EACA,iBAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,yBAAA;EACA,mBAAA;EACA,cAAA;EACA,eAAA;AACF;;AAEA;EACE,mBAAA;AACF;;AAEA;EACE,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,SAAA;AACF;;AAEA;EACE,aAAA;EACA,qBAAA;EACA,SAAA;EACA,eAAA;AACF;;AAEA;EACE,SAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;AACF;;AAEA;EACE,eAAA;EACA,cAAA;AACF;;AAEA;EACE,iBAAA;EACA,eAAA;EACA,cAAA;EACA,mBAAA;AACF;;AAEA;EACE,SAAA;EACA,eAAA;EACA,cAAA;AACF;;AAEA;EACE,aAAA;EACA,sBAAA;EACA,SAAA;AACF;;AAEA;EACE,SAAA;EACA,aAAA;EACA,eAAA;EACA,qBAAA;EACA,QAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;AACF;;AAEA;EACE,eAAA;EACA,gBAAA;EACA,cAAA;AACF;;AAEA;EACE,aAAA;EACA,sBAAA;EACA,SAAA;AACF","sourcesContent":[".root {\n  display: block;\n}\n\n.pageHeader {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  margin-bottom: 16px;\n}\n\n.pageTitle {\n  font-size: 20px;\n  font-weight: 600;\n  color: #18181b;\n  margin: 0 auto 0 0;\n}\n\n.segmentedControl {\n  display: flex;\n  gap: 2px;\n  background: #f4f4f5;\n  border-radius: 6px;\n  padding: 2px;\n}\n\n.segmentButtonActive {\n  padding: 4px 12px;\n  font-size: 13px;\n  font-weight: 500;\n  border-radius: 4px;\n  border: none;\n  background: #ffffff;\n  color: #18181b;\n  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);\n  cursor: default;\n}\n\n.toolbar {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  padding: 10px 0;\n  margin-bottom: 8px;\n}\n\n.periodRow {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  column-gap: 16px;\n  row-gap: 10px;\n  padding: 16px;\n  background: #ffffff;\n  border: 1px solid #e4e4e7;\n  border-radius: 8px;\n}\n\n.presetGroup {\n  display: flex;\n  gap: 4px;\n  background: #f4f4f5;\n  border-radius: 6px;\n  padding: 2px;\n}\n\n.presetButton {\n  padding: 3px 10px;\n  font-size: 13px;\n  font-weight: 500;\n  border-radius: 4px;\n  border: 1px solid transparent;\n  background: transparent;\n  color: #71717a;\n  cursor: pointer;\n}\n\n.presetButton:hover {\n  color: #3f3f46;\n}\n\n.presetButtonActive {\n  background: #ffffff;\n  color: #18181b;\n  border-color: #e4e4e7;\n  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);\n}\n\n.dayChips {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  flex-wrap: wrap;\n}\n\n.dayChip {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  white-space: nowrap;\n  padding: 6px 14px;\n  font-size: 13px;\n  border-radius: 999px;\n  border: 1px solid #d4d4d8;\n  background: #ffffff;\n  color: #3f3f46;\n  cursor: pointer;\n  transition: border-color 0.15s ease, color 0.15s ease, background-color 0.15s ease;\n}\n\n.dayChip:hover {\n  border-color: #18181b;\n  color: #18181b;\n}\n\n.dayChipActive {\n  border-color: #18181b;\n  background: #18181b;\n  color: #ffffff;\n}\n\n.dayChipCount {\n  font-size: 12px;\n  color: #a1a1aa;\n}\n\n.dayChipActive .dayChipCount {\n  color: #d4d4d8;\n}\n\n.pickDateLabel {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  font-size: 13px;\n  color: #71717a;\n}\n\n.dateInput {\n  padding: 4px 8px;\n  font-size: 13px;\n  border-radius: 6px;\n  border: 1px solid #e4e4e7;\n  background: #ffffff;\n  color: #3f3f46;\n}\n\n.readout {\n  margin-left: auto;\n  white-space: nowrap;\n  font-size: 13px;\n  color: #71717a;\n}\n\n.handoffCard {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: 16px;\n  margin-top: 12px;\n  padding: 16px;\n  background: #ffffff;\n  border: 1px solid #e4e4e7;\n  border-radius: 8px;\n}\n\n.handoffIcon {\n  flex-shrink: 0;\n  color: #71717a;\n}\n\n.handoffText {\n  margin-right: auto;\n  min-width: 0;\n}\n\n.handoffTitle {\n  margin: 0;\n  font-size: 15px;\n  font-weight: 600;\n  color: #18181b;\n}\n\n.handoffSubtitle {\n  margin: 2px 0 0;\n  font-size: 13px;\n  color: #71717a;\n}\n\n.handoffButton {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  flex-shrink: 0;\n  padding: 6px 14px;\n  font-size: 13px;\n  font-weight: 500;\n  border-radius: 6px;\n  border: 1px solid #e4e4e7;\n  background: #ffffff;\n  color: #18181b;\n  cursor: pointer;\n}\n\n.handoffButton:hover {\n  background: #f4f4f5;\n}\n\n.dayList {\n  margin-top: 12px;\n  padding: 16px;\n  background: #ffffff;\n  border: 1px solid #e4e4e7;\n  border-radius: 8px;\n  display: flex;\n  flex-direction: column;\n  gap: 24px;\n}\n\n.dayListHeader {\n  display: flex;\n  align-items: baseline;\n  gap: 10px;\n  flex-wrap: wrap;\n}\n\n.dayListTitle {\n  margin: 0;\n  font-size: 17px;\n  font-weight: 600;\n  color: #18181b;\n}\n\n.dayListCount {\n  font-size: 17px;\n  color: #a1a1aa;\n}\n\n.dayListSummary {\n  margin-left: auto;\n  font-size: 13px;\n  color: #71717a;\n  white-space: nowrap;\n}\n\n.emptyState {\n  margin: 0;\n  font-size: 13px;\n  color: #71717a;\n}\n\n.dayGroup {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n.dayHeading {\n  margin: 0;\n  display: flex;\n  flex-wrap: wrap;\n  align-items: baseline;\n  gap: 8px;\n  font-size: 18px;\n  font-weight: 600;\n  color: #18181b;\n}\n\n.dayHeadingQuiet {\n  font-size: 15px;\n  font-weight: 400;\n  color: #71717a;\n}\n\n.dayRows {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": `ActionAreaView-module__root___kCwj9`,
	"pageHeader": `ActionAreaView-module__pageHeader___NGat7`,
	"pageTitle": `ActionAreaView-module__pageTitle___sLuXU`,
	"segmentedControl": `ActionAreaView-module__segmentedControl___RmFMr`,
	"segmentButtonActive": `ActionAreaView-module__segmentButtonActive___l6Hxd`,
	"toolbar": `ActionAreaView-module__toolbar___aIZnQ`,
	"periodRow": `ActionAreaView-module__periodRow___xj8aK`,
	"presetGroup": `ActionAreaView-module__presetGroup___ggd4r`,
	"presetButton": `ActionAreaView-module__presetButton___JAFbo`,
	"presetButtonActive": `ActionAreaView-module__presetButtonActive___ER3oT`,
	"dayChips": `ActionAreaView-module__dayChips___u0Spq`,
	"dayChip": `ActionAreaView-module__dayChip___t9tUD`,
	"dayChipActive": `ActionAreaView-module__dayChipActive___qFG63`,
	"dayChipCount": `ActionAreaView-module__dayChipCount___IvCRO`,
	"pickDateLabel": `ActionAreaView-module__pickDateLabel___F1q97`,
	"dateInput": `ActionAreaView-module__dateInput___FaE8j`,
	"readout": `ActionAreaView-module__readout___BcLSV`,
	"handoffCard": `ActionAreaView-module__handoffCard___G3bVf`,
	"handoffIcon": `ActionAreaView-module__handoffIcon___ZAAOr`,
	"handoffText": `ActionAreaView-module__handoffText___wfqY9`,
	"handoffTitle": `ActionAreaView-module__handoffTitle___UZ_Od`,
	"handoffSubtitle": `ActionAreaView-module__handoffSubtitle___lhKDh`,
	"handoffButton": `ActionAreaView-module__handoffButton___K1940`,
	"dayList": `ActionAreaView-module__dayList___fnOwt`,
	"dayListHeader": `ActionAreaView-module__dayListHeader___DgR47`,
	"dayListTitle": `ActionAreaView-module__dayListTitle___ELI6U`,
	"dayListCount": `ActionAreaView-module__dayListCount___hVaVg`,
	"dayListSummary": `ActionAreaView-module__dayListSummary___aHkHn`,
	"emptyState": `ActionAreaView-module__emptyState___PGM7v`,
	"dayGroup": `ActionAreaView-module__dayGroup___ADlHF`,
	"dayHeading": `ActionAreaView-module__dayHeading___qH_yu`,
	"dayHeadingQuiet": `ActionAreaView-module__dayHeadingQuiet___CN_Ae`,
	"dayRows": `ActionAreaView-module__dayRows___miaNA`
};
module.exports = ___CSS_LOADER_EXPORT___;
